<template>
  <component
    :is="props.bg ? 'div' : 'img'"
    :class="['lazy-image', { 'lazy-image--bg': props.bg }]"
    :alt="alt"
    :src="src"
    loading="lazy"
  />
</template>

<script setup lang="ts">
  import { computed } from 'vue';

  export interface ILazyImageProps {
    alt: string;
    src: string;
    bg?: string;
    fit?: string;
    aspect?: string | number;
  }

  const props = defineProps<ILazyImageProps>();

  const bg = computed<string | undefined>(() => (props.bg ? `url(${props.bg})` : undefined));
</script>

<style lang="scss" scoped>
  .lazy-image {
    display: block;
    object-fit: v-bind(fit);
    aspect-ratio: v-bind(aspect);

    &--bg {
      background-image: v-bind(bg);
      background-size: cover;
      background-repeat: no-repeat;
    }

    &:not(&--bg) {
      max-width: 100%;
      max-height: 100%;
    }

    &[data-src] {
      position: relative;

      &:after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: linear-gradient(150.35deg, rgba(0, 0, 0, 0.88) 0%, rgba(43, 55, 67, 0) 37.86%);
      }

      &:before {
        content: '';
        position: absolute;
        right: 0;
        bottom: 0;
        width: 100%;
        height: 100%;
        background: linear-gradient(344.7deg, rgba(0, 0, 0, 0.8) 0.61%, rgba(0, 0, 0, 0) 51.65%);
      }
    }
  }
</style>
